import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ColorScssService } from '../../shared/service/color-scss.service';
import { environment } from '../../../environments/environment';



@Component({
  selector: 'app-modern',
  templateUrl: './modern.component.html',
  styleUrls: ['./modern.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModernComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private title: Title,
    public colorPicker: ColorScssService,
    private router: Router,
    private metaService: Meta) { }

  private readonly imgSEO: string = environment.imageSEO

  ngOnInit() {
    this.title.setTitle(this.route.snapshot.data['title']);
    this.colorPicker.setColorScheme('color-2');
    this.metaService.addTag({ name: 'description', content: 'Descubra o personal trainer ideal para acompanhá-lo em seus treinamentos. Oferecemos treinadores personalizados, experientes e dedicados. Encontre o seu hoje!' });
    this.metaService.addTag({ name: 'author', content: 'Think Sites' });
    this.metaService.addTag({ name: 'keywords', content: 'personal trainer, treinamento, treinador, fitness, exercício, saúde' });
    this.metaService.addTag({ name: 'robots', content: 'index, follow' });
    this.metaService.addTag({ name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1' });
    this.metaService.addTag({ name: 'geo.placename', content: 'Fit Up' });
    this.metaService.addTag({ name: 'geo.region', content: 'BR' });
    this.metaService.addTag({ rel: 'canonical', href: 'https://www.fitupxp.web.app/home' });
    this.metaService.addTag({ property: 'bussiness:contact_data:country_name', content: 'São Paulo' });
    this.metaService.addTag({ property: 'bussiness:contact_data:website', content: 'https://www.fitupxp.web.app/home' });
    this.metaService.addTag({ property: 'bussiness:contact_data:region', content: 'São Paulo' });
    this.metaService.addTag({ property: 'og:url', content: 'https://www.fitupxp.web.app/home' });
    this.metaService.addTag({ property: 'og:title', content: 'Encontre o Personal Trainer Perfeito para Seus Treinamentos' });
    // this.metaService.addTag({ property: 'og:image', content: `${this.imgSEO}` });
    // this.metaService.addTag({ property: 'og:image:secure', content: `${this.imgSEO}` });
    this.metaService.addTag({ property: 'og:description', content: `Descubra o personal trainer ideal para acompanhá-lo em seus treinamentos. Oferecemos treinadores personalizados, experientes e dedicados. Encontre o seu hoje!` });
    this.metaService.addTag({ property: 'og:type', content: 'website' });
    this.metaService.addTag({ property: 'og:locale', content: 'pt-br' });

    // Verifica se o fragmento da URL está definido
    if (window.location.hash && window.location.hash !== '#') {
      // Redireciona para a rota raiz
      this.router.navigateByUrl('/');
    }
  }
}
